import FieldsetAccountGeneral from './FieldsetAccountGeneral.yaml?component';
import UcAccountHeader from './UcAccountHeader.yaml?component';


export { FieldsetAccountGeneral, UcAccountHeader };